/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Enum representing treatment types for the activity.
 */
export enum ActivityTreatments {
  /**
   * Indicates that only the recipient should be able to see the message even if the activity
   * is being sent to a group of people.
   */
  Targeted = 'targeted',
}
